import {BlockForm} from './blockdemat.model';
import {ResponseForm} from './responsedemat.model';
import {FormState, FormType} from './global.model';
import {UrlModel} from '../../../services/url/url.model';
import {GestionnaireDemat} from '../../../services/individus/gestionnaire.model';


export interface ResponseCount {
 count_waiting: number;
 count_traite: number;
 count_traitement: number;
 count_incomplet: number;
 count_archive: number;
}

export enum FormVisibility {
  Intern = 1,
  Extern = 2
}
export interface CategorieDemat {
  id?: number;
  name?: string;
  description?: string;
  created_by?: string;
  active?: boolean;
  dt_created?: Date;
  dt_updated?: Date;
}

export interface FormModel { // FormModelDemat
  id?: number;
  uuid?: string;
  type?: FormType;
  date_debut?: string;
  date_fin?: string;
  nom?: string;
  description?: string;
  blocks?: BlockForm[];
  block_admin?: BlockForm;
  email_generic?: string;
  signature_email?: string;
  form_responses?: ResponseForm[];
  responses_send?: number;
  responses_total?: number;
  private?: boolean;
  state?: FormState;
  gestionnaires_obj?: GestionnaireDemat[];
  gestionnaires?: number[];
  categories_obj?: CategorieDemat[];
  categories?: number[];
  url_obj?: UrlModel[];
  form_url?: number;
  url_slug?: string;
  titre_documents?: string;
  dt_created?: Date;
  dt_updated?: Date;
  responses_count?: ResponseCount[];
  attachments?: AttachmentsFormModel[];
  visibility?: FormVisibility;
  is_accepted_like_admissible?: boolean; // considère-t-on que pour ce formulaire, le statut sera labellisé en "Recevable" à la place de "Acceptée"
  visibility_avis?: boolean; // selon le paramétrage du formulaire : visibilité des avis entre sollicités [_]
}

export interface AttachmentsFormModel {
  id: number;
  file: File;
  form?: number;
  name?: string;
  size?: number;
}

export interface DemandeurFilterModel {
  form?: FormModel;
  onlySurvey?: boolean;
}
